import { Component } from "react";
import Popup from "../../../common/Popup";
import {
    DKCalendar, DKLabel, DKInput, DKButton, DKLine, DKSpinner, TOAST_TYPE,
    showToast, DKIcon, removeLoader, showLoader, DKTooltipWrapper,
    DKIcons
} from "deskera-ui-library";
import ic_info_message from "../../../../assets/icons/ic_info_gray01.png";
import Utility, { deepClone } from "../../../../utility/Utility";
import { EDIT_APPENDIX_8A_FORM } from "./SGReportsConstant";
import ReportService from "../../../../services/ReportService";
import MaskInput from "../../../../SharedComponents/MaskInput/MaskInput";
import date_range from "../../../../assets/icons/date_range.svg";
import moment from "moment";
import { DATE_FORMAT, FORMAT, REACT_TOOLTIP_CONST, TENENT_COUNTRY } from "../../../../constants/Constant";
import { TENANT, TenantService } from "../../../../managers/TenantManagerService";
import ReactTooltip from "react-tooltip";
export default class EditAppendix8AForm extends Component {
    editAppendix8AForm = deepClone(EDIT_APPENDIX_8A_FORM)
    defaultValues = {}
    canValidate = false;
    interval;
    constructor(props) {
        super(props)
        if (this.props.data) {
            this.defaultValues = this.props.data;
            this.getAppendix8AFormData()
        }
    }
    selectYear = {
        toggle: false,
        startDate: moment(moment().format()).startOf('month'),
        endDate: moment(moment().format()).endOf('month'),
        defaultDate: false,
        hasError: false,
        errorMsg: 'End date should not be less than Start date'
    }
    getAppendix8AFormData() {
        let param = {
            year: this.defaultValues.year,
            cpfAccountNo: this.defaultValues.cpfAccount
        }
        showLoader()
        ReportService.getIRASFormData(param, this.defaultValues['employee'].id).then(res => {
            removeLoader()
            this.defaultValues = {
                ...this.defaultValues,
                ...res,
                ...res.address
            }
            if (this.defaultValues['occupationPeriod']) {
                let range = this.defaultValues['occupationPeriod'].split('-')
                this.selectYear.startDate = moment(range[0], DATE_FORMAT.SLASH.DDMMYYYY).format();
                this.selectYear.endDate = moment(range[1], DATE_FORMAT.SLASH.DDMMYYYY).format()
            }
            if(Utility.isEmpty(this.defaultValues['furnitureAndFittingType'])) {
                this.defaultValues['furnitureAndFittingType'] = 'PARTIALLY_FURNISHED'
            }
            if(Utility.isEmpty(this.defaultValues['address'])) {
                this.defaultValues['country'] = TenantService.get(TENANT.COUNTRY_CODE)
            }

            this.updateState()
        }, error => {
            removeLoader()
            console.log(error);
        })
    }
    updateState() {
        this.setState({
            ...this.state
        })
    }
    componentWillUnmount() {
        if (this.interval) {
            clearInterval(this.interval)
        }
    }
    getOccupationPeriod(data) {
        if (data) {
            const selectedDateArray = data.split(' - ');
            if (selectedDateArray[0] === DATE_FORMAT.SLASH.DDMMYYYY || selectedDateArray[1] === DATE_FORMAT.SLASH.DDMMYYYY) {
                return;
            }
            const from = Utility.formatDate(selectedDateArray[0], DATE_FORMAT.SLASH.DDMMYYYY);
            const to = Utility.formatDate(selectedDateArray[1], DATE_FORMAT.SLASH.DDMMYYYY);
            let occupationPeriod = from + ' - ' + to;
            return occupationPeriod
        } else {
            return
        }

    }
    /**
   * Function to calculate number of days from occupation period
   */
    calculateNumberofDays(occupationPeriod) {
        let days = 0;
        const dateRange = occupationPeriod.split('-');
        if (dateRange && dateRange.length > 1) {
            const startDate = dateRange[0]
                ? moment(dateRange[0], DATE_FORMAT.SLASH.DDMMYYYY)
                    .subtract(1, 'days')
                    .format(DATE_FORMAT.SLASH.DDMMYYYY)
                : '';
            const endDate = dateRange[1]
                ? moment(dateRange[1], DATE_FORMAT.SLASH.DDMMYYYY).format(DATE_FORMAT.SLASH.DDMMYYYY)
                : '';
            days = moment(endDate, DATE_FORMAT.SLASH.DDMMYYYY).diff(
                moment(startDate, DATE_FORMAT.SLASH.DDMMYYYY),
                'days'
            );
        }
        return days;
    }
    updateRequired(filedArray, columnCode, isRequired) {
        if (filedArray) {
            let ind = filedArray.findIndex(field => field.columnCode === columnCode)
            if (ind !== -1) {
                filedArray[ind].required = isRequired;
            }
        }
        return filedArray
    }
    /**
     * Function to set validators when AV is filled
     */
    onAnnualValueChange(event, index, obj) {
        if (event) {
            const annualvalue = this.defaultValues['annualValue'];
            const value = annualvalue ? parseFloat(annualvalue) : 0;
            if (value && value > 0) {
                const furnitureVale = this.defaultValues['furnitureAndFittingType']
                this.editAppendix8AForm.accommodationDetail = this.updateRequired(this.editAppendix8AForm.accommodationDetail, 'furnitureAndFittingType', true)
                this.editAppendix8AForm.accommodationDetail = this.updateRequired(this.editAppendix8AForm.accommodationDetail, 'rentPaid', false)


                if (furnitureVale && furnitureVale === 'FULLY_FURNISHED') {
                    const furnitureFittingsValue = (value * 50) / 100;
                    this.defaultValues['valueOfFurniture'] = furnitureFittingsValue;
                    const taxableValue = value + furnitureFittingsValue;
                    this.defaultValues['taxableValueOfRec'] = taxableValue;
                    this.setTotalTaxableResidenceValue(true);
                } else if (
                    furnitureVale &&
                    furnitureVale === 'PARTIALLY_FURNISHED'
                ) {
                    const furnitureFittingsValue = (value * 40) / 100;
                    this.defaultValues['valueOfFurniture'] = furnitureFittingsValue;
                    const taxableValue = value + furnitureFittingsValue;
                    this.defaultValues['taxableValueOfRec'] = taxableValue;
                    this.setTotalTaxableResidenceValue(true);
                } else {
                    this.defaultValues['taxableValueOfRec'] = value;
                    this.setTotalTaxableResidenceValue(true);
                }
            } else {
                this.editAppendix8AForm.accommodationDetail = this.updateRequired(this.editAppendix8AForm.accommodationDetail, 'furnitureAndFittingType', false)
                const furnitureFttings = this.defaultValues['furnitureAndFittingType'];
                if (!furnitureFttings) {
                    this.defaultValues['furnitureAndFittingType'] = 'PARTAIL_FURNISHED'
                }
                this.defaultValues['valueOfFurniture'] = 0
                this.editAppendix8AForm.accommodationDetail = this.updateRequired(this.editAppendix8AForm.accommodationDetail, 'rentPaid', true)
                this.defaultValues['taxableValueOfRec'] = this.defaultValues['rentPaid']
                this.setTotalTaxableResidenceValue(true);
            }
        }
    }
    calculateTxableUtilitiesHouseKeeping(event) {
        if (event) {
            let utilitiesValue = this.defaultValues['utilityActualAmount'];
            utilitiesValue = utilitiesValue ? parseFloat(utilitiesValue) : 0;
            let driverCost = this.defaultValues['driverActualAmount'];
            driverCost = driverCost ? parseFloat(driverCost) : 0;
            let serventCost = this.defaultValues['servantActualAmount'];
            serventCost = serventCost ? parseFloat(serventCost) : 0;
            const taxableValue = utilitiesValue + driverCost + serventCost;
            this.defaultValues['taxableValueOfUtilsAndHousekeeping'] = taxableValue;

        }
    }
    setTotalTaxableResidenceValue(event) {
        if (event) {
            let taxableValue = this.defaultValues['taxableValueOfRec']//this.appendix8AForm.get('taxableValueOfRec').value;
            taxableValue = taxableValue ? parseFloat(taxableValue) : 0;
            let totalRent = this.defaultValues['rentPaidByEmp'] //this.appendix8AForm.get('rentPaidByEmp').value;
            totalRent = totalRent ? parseFloat(totalRent) : 0;
            const totalTaxableValue = taxableValue - totalRent;
            this.defaultValues['totalTaxableValueOfRec'] = totalTaxableValue
            
        }
    }
    getHeder() {
        return (
            <div className="row justify-content-between">
                <DKLabel className="fw-m fs-l" text="Edit Appendix 8A" />
                <div className="d-flex">
                    <DKButton className="bg-gray1 border-m mr-l" title="Cancel" onClick={() => this.props.onClose()} />
                    <DKButton className="bg-app text-white" title="Save" onClick={() => this.save()} />
                </div>
            </div>
        )
    }
    save() {
        this.canValidate = true;
        this.updateState()
        this.interval = setTimeout(() => {
            if (this.validateForm()) {
                return;
            }
            let param = this.prepareJSONForSubmit()
            showLoader()
            ReportService.saveAppendix8A(param).then(res => {
                removeLoader()
                if (param && param.id) {
                    showToast("Form updated successfully", TOAST_TYPE.SUCCESS);
                } else {
                    showToast("Form saved successfully", TOAST_TYPE.SUCCESS);
                }

                this.props.onClose()
            }, error => {
                removeLoader()
                showToast("Somthing went wrong", TOAST_TYPE.FAILURE);
            })
        }, 100)
    }
    validateForm() {
        let isInvalid = false;
        this.editAppendix8AForm.employeeDetail.forEach(field => {
            if (!field.isValid) {
                isInvalid = true;
            }
        })
        this.editAppendix8AForm.accommodationDetail.forEach(field => {
            if (!field.isValid) {
                isInvalid = true;
            }
        })
        this.editAppendix8AForm.hotelAccommodationDetail.forEach(field => {
            if (!field.isValid) {
                isInvalid = true;
            }
        })
        this.editAppendix8AForm.otherDetail.forEach(field => {
            if (!field.isValid) {
                isInvalid = true;
            }
        })
        return isInvalid;
    }
    prepareJSONForSubmit() {
        let address = {
            addressLine1: this.defaultValues.addressLine1,
            addressLine2: this.defaultValues.addressLine2,
            addressLine3: this.defaultValues.addressLine3,
            city: this.defaultValues.city,
            country: this.defaultValues.country,
            fullAddress: this.defaultValues.fullAddress,
            zipCode: this.defaultValues.zipCode,
            state: this.defaultValues.state
        }
        let param = {
            ...this.defaultValues,
            address: address
        }
        return param
    }
    getFieldValue(obj) {
        switch (obj.key) {
            case 'employeeName':
                return this.defaultValues['employee'].name;
            case 'occupationPeriod':
                return this.getOccupationPeriod(this.defaultValues['occupationPeriod'])
            default:
                if (obj.options && obj.options.length != 0) {
                    if (obj.options[0].id) {
                        return obj.options.find(o => o.id == this.defaultValues[obj.key])
                    } else {
                        return obj.options.find(o => o == this.defaultValues[obj.key])
                    }
                }
                return this.defaultValues[obj.key];
        }

    }
    onChange(value, index, obj) {

        this.defaultValues[obj.key] = (value && value.id) ? value.id : value;
        switch (obj.key) {
            case "actualHotelAccommodation":
            case "hotelAccommodationAmountEmployee":
                let actualHotelAccommodation = this.defaultValues['actualHotelAccommodation'] ? this.defaultValues['actualHotelAccommodation'] : 0;
                let hotelAccommodationAmountEmployee = this.defaultValues['hotelAccommodationAmountEmployee'] ? this.defaultValues['hotelAccommodationAmountEmployee'] : 0;
                this.defaultValues['taxableHotelAccommodation'] = parseFloat(actualHotelAccommodation) - parseFloat(hotelAccommodationAmountEmployee);
                this.updateState()
                break;
            case "rentPaid":
            case "annualValue":
            case "furnitureAndFittingType":
                this.onAnnualValueChange(value, index, obj)
                this.updateState()
                break;
            case "driverActualAmount":
            case "utilityActualAmount":
            case "servantActualAmount":
                this.calculateTxableUtilitiesHouseKeeping(value, index, obj)
                this.updateState()
                break;
            case "rentPaidByEmp":
                this.setTotalTaxableResidenceValue(true);
                this.updateState();
                break;

        }
        this.updateState()
    }
    validator(value, index, obj) {
        if (obj.validation && obj.validation.regExp) {
            const regex = new RegExp(obj.validation.regExp);
            obj.isValid = regex.test(value);
            return regex.test(value);
        } else if (obj.required && typeof value === "string" && Utility.isEmpty(value.trim())) {
            obj.isValid = false
            return false;
        } else if (obj.required && Utility.isEmpty(value) && (typeof value === "number" && value !== 0)) {
            obj.isValid = false
            return false;
        } else if ((obj.validation) && (obj.validation.maxLength) && (obj.validation.maxLength < value.length)) {
            obj.isValid = false
            return false;
        } else if ((obj.validation) && (obj.validation.minValue) && (value < obj.validation.minValue)) {
            obj.isValid = false
            return false;
        } else {
            obj.isValid = true;
            return true;
        }
    }
    renderCalendarForDateSelect(value, index, obj) {
        return (
            <div className="ml-l">
                {this.selectYear.toggle && (
                    <DKCalendar
                        className="position-absolute border-m shadow-m bg-white z-index-6 "
                        isDateRange={true}
                        startDate={this.selectYear.startDate ? new Date(this.selectYear.startDate) : new Date()}
                        endDate={this.selectYear.endDate ? new Date(this.selectYear.endDate) : new Date()}
                        onClose={() => {
                            if (moment(this.selectYear.startDate).diff(this.selectYear.endDate) <= 0 || this.selectYear.endDate == null) {
                                this.selectYear = {
                                    toggle: false,
                                    startDate: this.selectYear.startDate,
                                    endDate: this.selectYear.endDate,
                                    defaultDate: false,
                                    hasError: false
                                };
                            } else {
                                this.selectYear = {
                                    toggle: false,
                                    startDate: this.selectYear.startDate,
                                    endDate: this.selectYear.endDate,
                                    defaultDate: false,
                                    hasError: true,
                                    errorMsg: "End date should not be less than Start date"
                                };
                            }

                            this.updateState()
                        }}
                        onSelectDate={(start, end) => {
                            if (start && end) {
                                let startDate = start;
                                let endDate = end;
                                if (moment(startDate).diff(endDate) <= 0 || endDate == null) {
                                    this.selectYear = {
                                        toggle: false,
                                        startDate: startDate,
                                        endDate: endDate,
                                        defaultDate: false,
                                        hasError: false
                                    };
                                    this.defaultValues[obj.key] = `${moment(new Date(this.selectYear.startDate)).format(DATE_FORMAT.SLASH.DDMMYYYY)} - ${moment(new Date(this.selectYear.endDate)).format(DATE_FORMAT.SLASH.DDMMYYYY)}`

                                    const numberOfDays = this.calculateNumberofDays(this.defaultValues[obj.key]);
                                    this.defaultValues['days'] = numberOfDays;
                                } else {
                                    this.selectYear = {
                                        toggle: false,
                                        startDate: startDate,
                                        endDate: endDate,
                                        defaultDate: false,
                                        hasError: true,
                                        errorMsg: "End date should not be less than Start date"
                                    };
                                }
                                this.updateState()
                            }
                        }}

                    />
                )}
            </div>
        )
    }
    getErrorMessage(obj) {
        let errorMessage;
        if (Utility.isEmpty(this.getFieldValue(obj)) && obj.required) {
            errorMessage = 'Please enter a valid details.';
        } else {
            errorMessage = obj.errorMessage
        }
        return errorMessage
    }
    getTooltip(obj) {
        return (
            <div class="custom-tooltip position-relative width-auto ">
                <DKIcon
                    src={ic_info_message}
                    className="ml-s ic-s ml-r  cursor-hand "
                    style={{ opacity: 0.4 }}
                />
                <span class={`custom-tooltiptext dk-input-holder border-radius-m 
                                    shadow-m bg-white text-dark-gray border-m 
                                    position-fixed p-m border-box z-index-6 ${obj.tooltipClass}`}>
                    <DKLabel text={obj.tooltipText}/>
                </span>
            </div>
        )
    }
    renderField(obj, index) {
        return (
            <>
                {!obj.showMask && <>
                    <div className=" row p-h-r ">
                        <DKLabel className="" text={`${obj.name} ${obj.required ? "*" : ""}`} />
                        {obj.tooltipText && obj.tooltipText != "" && (
                                this.getTooltip(obj)
                        )}
                    </div>

                    <div className="row ">

                        <DKInput
                            key={obj.key}
                            className={`p-v-s p-h-r parent-height ${obj.type !== "date-range" ? "mb-s" : ""}`}
                            icon={obj.icon}
                            title={""}
                            placeholder={obj.name}
                            value={this.getFieldValue(obj)}
                            options={obj.options}
                            type={obj.type}
                            errorMessage={this.getErrorMessage(obj)}
                            labelClassName=" text-align-left "
                            canValidate={this.canValidate || obj.canValidate}
                            onChange={(value) => {
                                obj.canValidate = true
                                this.onChange(value, index, obj);
                            }}
                            validator={(value) => {
                                return this.validator(value, index, obj)
                            }}
                            tooltip={{
                                content: obj.tooltipText,
                                className: "warning-tooltip-prop",
                            }}
                            formatter={(obj) => {
                                /** How to render a selected option in case of object **/
                                return obj.name;
                            }}
                            dropdownConfig={{
                                className: "",
                                style: {},
                                allowSearch: obj.options && obj.options.length > 6 ? true : false,
                                searchableKey: "name",
                                data: obj.options,
                                renderer: (index, obj) => {
                                    /** How to render value in Dropdown in case of object **/
                                    return <DKLabel text={`${obj.name}`} />;
                                },
                                onSelect: (index, obj) => {

                                },
                            }}
                            direction={obj.direction}
                            required={obj.required}
                            readOnly={obj.readOnly}
                        />
                        {obj.type == "date-range" && <DKIcon className=" z-index-1 cursor-hand" style={{ marginLeft: -46, opacity: .5 }} src={date_range} onClick={() => {
                            this.selectYear = {
                                toggle: (this.selectYear.toggle) ? false : true,
                                startDate: this.selectYear.startDate,
                                endDate: this.selectYear.endDate,
                                defaultDate: true
                            }
                            this.updateState()
                        }} />}
                    </div></>}
                {this.selectYear.hasError && <DKLabel className="text-red" text={this.selectYear.errorMsg} />}
                {obj.type == "date-range" && this.renderCalendarForDateSelect(this.getFieldValue(obj), index, obj)}
                {obj.showMask &&
                    <MaskInput
                        setRef={(ref) => obj['showMask'] = ref}
                        showMask={true}
                        className={"p-v-s p-h-r"}
                        title={obj.name}
                        direction={obj.direction}
                        value={this.getFieldValue(obj)}
                        errorMessage={obj.errorMsg}
                        readOnly={obj.readOnly}
                        showMaskUnmaskInline={obj.showMaskUnmaskInline}
                        required={obj.required}
                        tooltip={{
                            content: obj.tooltipText,
                            className: "warning-tooltip-prop",
                        }}
                        onChange={(value) => {
                            this.onChange(value, index, obj);
                        }}
                        canValidate={obj.hasError}
                        invalid={obj.hasError}
                    />
                }
            </>
        )
    }
    renderForm() {
        return (
            <div className="parent-width">
                <div className="row row-responsive flex-wrap border-m border-radius-s card-shadow m-v-l  pt-s pb-xs">
                    {this.editAppendix8AForm.employeeDetail.map((field, index) => {

                        return (field.uiVisible) ? <div className="web-width-50 pb-xs">{this.renderField(field, index)}</div> : null
                    })}
                </div>

                <DKLabel className="fw-m fs-l" text="2. Accommodation and related benefits provided by Employer" />
                <div className="row row-responsive flex-wrap border-m border-radius-s card-shadow m-v-l  pt-s" style={{
                    display: "flex",
                    alignItems: "inherit",
                    boxSizing: "border-box",
                    justifyContent: "space-between"
                }}>
                    {this.editAppendix8AForm.accommodationDetail.map((field, index) => {

                        return (field.uiVisible) ? (<div className="web-width-50 pb-xs" style={{
                            justifyContent: "space-between",
                            display: "flex",
                            flexDirection: 'column'
                        }}>
                            {this.renderField(field, index)}
                        </div>) : null
                    })}
                </div>


                <DKLabel className="fw-m fs-l" text="3. Hotel accommodation provided" />
                <div className="row row-responsive flex-wrap border-m border-radius-s card-shadow m-v-l  pt-s" style={{
                    display: "flex",
                    alignItems: "inherit",
                    boxSizing: "border-box",
                    justifyContent: "space-between"
                }}>
                    {this.editAppendix8AForm.hotelAccommodationDetail.map((field, index) => {

                        return (field.uiVisible) ? (<div className="web-width-50 pb-xs" style={{
                            justifyContent: "space-between",
                            display: "flex",
                            flexDirection: 'column'
                        }}>
                            {this.renderField(field, index)}
                        </div>) : null
                    })}
                </div>

                <DKLabel className="fw-m fs-l" text="4. Others" />
                <div className="row row-responsive flex-wrap border-m border-radius-s card-shadow m-v-l  pt-s" style={{
                    display: "flex",
                    alignItems: "inherit",
                    boxSizing: "border-box",
                    justifyContent: "space-between"
                }}>
                    {this.editAppendix8AForm.otherDetail.map((field, index) => {

                        return (field.uiVisible) ? (<div className="web-width-50 pb-xs" style={{
                            justifyContent: "space-between",
                            display: "flex",
                            flexDirection: 'column'
                        }}>
                            {this.renderField(field, index)}
                        </div>) : null
                    })}
                </div>
            </div>
        )

    }
    render() {
        return (
            <Popup popupClass={"report-form-popup"} onClose={() => { }}>
                {this.getHeder()}
                {this.renderForm()}
            </Popup>
        )
    }
}